import gettext from '@sdk/lang/gettext';

import { SurveyStepType, SurveyCommentStepType, SurveyFinishStepType } from '../survey/types/';

import { Influence } from './NpsSurveyProvider/npsSurveyProvider.types';

export enum NpsSteps {
  rate = 1,
  influence = 2,
  comment1 = 3,
  finish = 4,
  finishCall = 5,
}

export const ACTIONABLE_STEPS_COUNT = 3;

export const STEPS_CONFIG = {
  [NpsSteps.rate]: {
    number: 1,
    subtitle: gettext('How likely are you to recommend Sling to another business?'),
  } as SurveyStepType,
  [NpsSteps.influence]: {
    number: 2,
    subtitle: gettext('Which of the following most influenced your rating?'),
  } as SurveyStepType,
  [NpsSteps.comment1]: {
    number: 3,
    text: gettext('Please tell us more'),
  } as SurveyCommentStepType,
  [NpsSteps.finish]: {
    title: gettext('Thank you for your input!'),
    subtitle: gettext(
      'We highly value your feedback and use it to keep improving our product for you.'
    ),
  } as SurveyFinishStepType,
  [NpsSteps.finishCall]: {
    title: gettext('Thank you for your input!'),
    subtitle: gettext(
      'We highly value your feedback and use it to keep improving our product. We would love to hear more from you over a call.'
    ),
  } as SurveyFinishStepType,
};

export const OTHER_INFLUENCE_KEY = 'Other';
export const RATING_INFLUENCE_OPTIONS: { value: Influence; label: Influence }[] = [
  { value: 'Customer support experience', label: 'Customer support experience' },
  { value: 'Employee scheduling', label: 'Employee scheduling' },
  { value: 'Time tracking', label: 'Time tracking' },
  { value: 'Team communication', label: 'Team communication' },
  { value: 'Labor cost management', label: 'Labor cost management' },
  { value: 'Task management', label: 'Task management' },
  { value: OTHER_INFLUENCE_KEY, label: 'Other' },
];
